import React from 'react'
import Link from 'gatsby-link'

import github from '../img/github-icon-inverted.svg'
import logo from '../img/kodeklubben_tolinjers_logo.svg'

const Navbar = () => (
  <nav className="navbar is-transparent">
    <div className="container">
      <div className="navbar-brand">
        <Link to="/" className="navbar-item">
          <figure className="image">
            <img src={logo} alt="Kodeklubben Ringerike" style={{ width: '299px' }} />
          </figure>
        </Link>
          <div className="navbar-burger">
              <a 
                role="button" 
                class="navbar-burger" 
                aria-label="menu" 
                aria-expanded="false"
                >
                  <span aria-hidden="true">
                     <Link className="navbar-item" to="/about">
                      &lt; Om oss &gt;
                     </Link> </span>  
                  <span aria-hidden="true">
                    <a 
                      className="navbar-item"
                      href="http://www.paraproduksjoner.no/kode/"
                      target="_blank" 
                    >
                    &lt; Webprogrammering &gt;
                    </a>   
                  </span>
              </a>
          </div>
      </div>
      <div className="navbar-start">
        <Link className="navbar-item" to="/about">
          &lt; Om oss &gt;
        </Link>        
        <a 
          className="navbar-item" 
          href="http://www.paraproduksjoner.no/kode/"
          target="_blank"
          >
        &lt; Webprogrammering &gt;
        </a>
      </div>
      <div className="navbar-end">
        <a
          className="navbar-item"
          href="https://github.com/kkringerike"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="icon">
            <img src={github} alt="Github" />
          </span>
        </a>
      </div>
    </div>
  </nav>
)

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js